import React, { useRef, useState, useEffect } from 'react';
import { useI18n } from '../hooks/useI18n';

// SDG Goals with exact colors and local icons from CISH
const sdgGoals = [
  { number: 2, title: 'ZERO HUNGER', color: '#DDA63A', icon: '/icons/key1.svg' },
  { number: 13, title: 'CLIMATE ACTION', color: '#3F7E44', icon: '/icons/key2.svg' },
  { number: 9, title: 'INDUSTRY, INNOVATION AND INFRASTRUCTURE', color: '#F36D25', icon: '/icons/key3.svg' },
  { number: 15, title: 'LIFE ON LAND', color: '#56C02B', icon: '/icons/key4.svg' },
  { number: 12, title: 'SUSTAINABLE PRODUCTION AND CONSUMPTION', color: '#BF8B2E', icon: '/icons/key5.svg' },
  { number: 3, title: 'GOOD HEALTH & WELL BEING', color: '#4C9F38', icon: '/icons/key6.svg' },
];

export default function KeyImpacts() {
  const { t } = useI18n();

  return (
    <section
      className="py-8 md:py-14 bg-white"
      data-testid="key-impacts"
    >
      <div className="container-cish">
        {/* Section heading */}
        <div className="section-heading">
          <img src="/icons/registration.svg" alt="" className="w-5 h-5 md:w-6 md:h-6" aria-hidden="true" />
          <h2 className="section-heading-text">{t('keyImpacts')}</h2>
        </div>

        {/* SDG Cards - Grid layout matching other sections */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {sdgGoals.map((goal, index) => (
            <div
              key={index}
              className="rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all transform hover:-translate-y-1 cursor-pointer"
              style={{ 
                backgroundColor: goal.color,
              }}
              data-testid={`impact-card-${index}`}
            >
              <div className="p-4 md:p-5 h-full flex flex-col">
                <div className="flex items-start justify-between mb-3">
                  <span className="text-2xl md:text-3xl font-bold text-white">
                    {goal.number}
                  </span>
                  <img 
                    src={goal.icon} 
                    alt="" 
                    className="w-8 h-8 md:w-10 md:h-10 object-contain"
                    aria-hidden="true"
                  />
                </div>
                <p className="text-[10px] md:text-xs font-semibold uppercase leading-tight text-white flex-1">
                  {goal.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
